import React from "react";

//import packages
import { useDecodedToken } from "../Routes/APP/PrivateRoute";
import { ActionCableConsumer } from "react-actioncable-provider";



//Component

const CableConsumer = ({ channelName, handleChannelInitialized, handleChannelConnected, handleDataReceived, handleConnectionDisconnect }) => {
	const user = useDecodedToken();

	return user ? (
		<ActionCableConsumer  //available methods for ActionCable: onConnected, onDisconnected, onInitialized,	onRejected,	onReceived
			channel={{ channel: channelName, user_id: user?.auth_token }}
			onReceived={handleDataReceived}
			onConnected={handleChannelConnected}
			onDisconnected={handleConnectionDisconnect}
		/>
	) : null;
};

export default CableConsumer;
